module.exports = __webpack_public_path__ + "static/media/onboarding-branding.eaade076.png";